__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-03-09-1773061449-stable-dev/";